import Utils from "../misc/Utils";
import Alert from "./Alert";
import Modals from "./Modals";

class Comments {
    static onCommentSubmit($element) {
        let form_el = $element;
        let entity_type = jQuery(form_el).attr('data-type') || "media";
        let entity_id = jQuery(form_el).attr('data-content') || "";
        let parent_id = jQuery(form_el).attr('data-parent') || "";
        let ajax_hash = jQuery(form_el).attr('data-ajax-hash') || "";
        let comment_body = jQuery(form_el).find(".comment_body").val() || "";

        if(!entity_id || !ajax_hash || ("" === comment_body)) {
            Alert.showGeneralAlert("Unable to save comment, try again");
            return false;
        }

        Utils.commit_ajax_action('add_comment', {
            'type': entity_type,
            'id': entity_id,
            'parent': parent_id,
            'comment': comment_body,
            'hash': ajax_hash
        }, function(data) {
            let html = [];
            if(data && data.status && ("error" === data.status)) {
                if(data.message) {
                    Alert.showGeneralAlert(data.message);
                } else {
                    Alert.showGeneralAlert("Error adding comment, try again");
                }
                return false;
            }
            if(!data.cargo) {
                Alert.showGeneralAlert("Refresh page to see your new comment");
                return false;
            }

            // empty comment body
            jQuery(form_el).find(".comment_body").val("");

            // add comment to DOM
            html.push("<li id=\"comment__"+ data.cargo.comment_id +"\" style=\"opacity: 0;\">");
            html.push("<div class=\"comment_container\">");
            html.push("<div class=\"avatar_container\">");
            html.push("<a href=\""+ data.cargo.author_url +"\" title=\""+ data.cargo.author_name +" User Profile\" class=\"avatar\">");
            html.push("<img src=\""+ data.cargo.author_avatar +"\" alt=\""+ data.cargo.author_name +" User Avatar\" class=\"active\" />");
            html.push("</a>");
            html.push("</div>");
            html.push("<div class=\"row meta\">");
            html.push("<div class=\"row title\">");
            html.push("<a href=\""+ data.cargo.author_url +"\" title=\""+ data.cargo.author_name +" User Profile\" class=\"name"+ ((data.cargo.author_is_vip || data.cargo.author_is_admin)?" larger_name":"") +"\">");

            if(data.cargo.author_is_admin) {
                html.push("<i class=\"fa fa-certificate\"></i>&nbsp;&nbsp;");
            } else if(data.cargo.author_is_top_user) {
                html.push("<i class=\"fas fa-poo\"></i>&nbsp;&nbsp;");
            } else if(data.cargo.author_is_vip) {
                html.push("<i class=\"fa fa-star\"></i>&nbsp;&nbsp;");
            }

            html.push(data.cargo.author_name +"</a>");
            html.push("<span class=\"timestamp\" title=\""+ data.cargo.comment_timestamp_attr +"\" data-timestamp=\""+ data.cargo.comment_timestamp +"\">"+ data.cargo.comment_timestamp_display +"</span>");
            html.push("</div>");
            html.push("<div class=\"row comment\">");
            html.push(data.cargo.comment_body);
            html.push("</div>");
            html.push("<div class=\"row actions\"><a href=\"#\" class=\"comment_reply\" data-comment=\""+ data.cargo.comment_id +"\">Reply</a>  <a href=\"#\" class=\"comment_delete\" data-type=\""+ entity_type +"\" data-comment=\""+ data.cargo.comment_id +"\" data-ajax-hash=\""+ data.cargo.delete_hash +"\">Delete</a></div>");
            html.push("<div class=\"row comment_reply_container comment_reply_container__"+ data.cargo.comment_id +" hidden\">");
            html.push("<form class=\"comment-form\" data-type=\""+ entity_type +"\" data-content=\""+ entity_id +"\" data-parent=\""+ data.cargo.comment_id +"\" data-ajax-hash=\""+ data.cargo.reply_hash +"\">");
            html.push("<textarea id=\"comment_body__"+ data.cargo.comment_id +"\" class=\"comment_body\" placeholder=\"Enter a comment\" data-default-value=\"@"+ data.cargo.author_name +" \">@"+ data.cargo.author_name +" </textarea>");
            html.push("<input type=\"submit\" value=\"Submit\" class=\"button\" />");
            html.push("</form>");
            html.push("</div>");
            html.push("</div>");
            html.push("</div>");
            html.push("</li>");

            if(data.cargo.parent_id) {
                jQuery("#content_comments__"+ data.cargo.parent_id).append( html.join("") );
                jQuery(".comment_reply_container__"+ data.cargo.parent_id).addClass("hidden").find("textarea").val("");
            } else {
                jQuery("#content_comments__base").append( html.join("") );
            }

            jQuery("html, body").animate({
                'scrollTop': (jQuery("#comment__"+ data.cargo.comment_id).offset().top - jQuery("header").height() - 15)
            }, 500, function() {
                jQuery("#comment__"+ data.cargo.comment_id).fadeTo(600, 1);
            });
        }, function() {
            Alert.showGeneralAlert("Something went wrong, try again");
        }, function() {
            jQuery(form_el).prop('disabled', false);
        });
    }
    static onCommentReplyLink($element) {
        let comment_id = $element.attr('data-comment') || "";
        let default_value;
        if(!comment_id) {
            return;
        }
        default_value = jQuery("#comment_body__"+ comment_id).attr('data-default-value') || "";
        jQuery("#comment__"+ comment_id +" .row.comment_reply_container__"+ comment_id).removeClass("hidden");
        jQuery("#comment_body__"+ comment_id).focus().val("").val(default_value);
    }
    static onCommentReplyCancel($element) {
        let comment_id = $element.attr('data-comment') || "";
        let default_value;
        if(!comment_id) {
            return;
        }
        default_value = jQuery("#comment_body__"+ comment_id).attr('data-default-value') || "";
        jQuery("#comment__"+ comment_id +" .row.comment_reply_container__"+ comment_id).addClass("hidden");
        jQuery("#comment_body__"+ comment_id).val( default_value ).blur();
    }
    static onCommentDelete($element) {
        let entity_type = $element.attr('data-type') || "media";
        let comment_id = $element.attr('data-comment') || "";
        let ajax_hash = $element.attr('data-ajax-hash') || "";
        let comment_el;
        if(!comment_id || !ajax_hash) {
            Alert.showGeneralAlert("Unable to delete comment");
            return;
        }
        comment_el = jQuery("#comment__"+ comment_id);
        if(!jQuery(comment_el).length) {
            return;
        }
        if(!confirm("Are you sure?")) {
            return;
        }
        // start to hide comment
        jQuery(comment_el).fadeTo(400, 0);
        Utils.commit_ajax_action('delete_comment', {
            'type': entity_type,
            'id': comment_id,
            'hash': ajax_hash
        }, function(data) {
            if(data && data.status && ("error" === data.status)) {
                if(data.message) {
                    Alert.showGeneralAlert(data.message);
                } else {
                    Alert.showGeneralAlert("Error deleting comment, try again");
                }
                jQuery(comment_el).fadeTo(400, 1);
                return false;
            }
            jQuery(comment_el).empty().remove();
        }, function() {
            jQuery(comment_el).fadeTo(400, 1);
            Alert.showGeneralAlert("Something went wrong, try again");
        });
    }
    static onCommentVote($element) {
        let rate_el = $element.find('.button');
        let	other_rate_el, other_rate_voted = false;
        let	entity_type = jQuery(rate_el).attr('data-type') || "media";
        let	comment_id = jQuery(rate_el).attr('data-comment') || "";
        let	value = jQuery(rate_el).attr('data-value') || "";
        let	ajax_hash = jQuery(rate_el).attr('data-ajax-hash') || "";
        let	intent = "save";

        if(!comment_id || !value || !ajax_hash) {
            Alert.showGeneralAlert("Unable to rate comment, try again");
            return false;
        }
        if("up" === value) {
            other_rate_el = jQuery("#comment_vote_container__"+ comment_id +" .votes .vote-down");
        } else {
            other_rate_el = jQuery("#comment_vote_container__"+ comment_id +" .votes .vote-up");
        }
        other_rate_voted = jQuery(other_rate_el).hasClass("voted-for");
        jQuery(other_rate_el).removeClass("voted-for");
        if(jQuery(rate_el).hasClass("voted-for")) {
            intent = "remove";
            jQuery(rate_el).removeClass("voted-for");
        } else {
            jQuery(rate_el).addClass("voted-for");
        }

        Utils.commit_ajax_action('rate_comment', {
            'type': entity_type,
            'id': comment_id,
            'value': value,
            'intent': intent,
            'hash': ajax_hash
        }, function(data) {
            let display_value = jQuery("#comment_vote_container__"+ comment_id +" .votes .row.value").text() || "";

            if(data && data.status && ("error" === data.status)) {
                if(data.message) {
                    Alert.showGeneralAlert(data.message);
                } else {
                    Alert.showGeneralAlert("Error rating comment, try again");
                }
                if("remove" === intent) {
                    jQuery(rate_el).addClass("voted-for");
                } else {
                    jQuery(rate_el).removeClass("voted-for");

                    if(other_rate_voted) {
                        jQuery(other_rate_el).addClass("voted-for");
                    }
                }
                return false;
            }

            if(data.cargo && data.cargo.display_value) {
                display_value = data.cargo.display_value;
            }
            if(jQuery("#comment_vote_container__"+ comment_id +" .votes .row.values").length) {
                if(typeof data.cargo.votes_down != "undefined") {
                    jQuery("#comment_vote_container__"+ comment_id +" .votes .row.values .value_display.value_up").text("+"+ data.cargo.votes_up);
                }

                if(typeof data.cargo.votes_down != "undefined") {
                    jQuery("#comment_vote_container__"+ comment_id +" .votes .row.values .value_display.value_down").text("-"+ data.cargo.votes_down);
                }
            } else {
                jQuery("#comment_vote_container__"+ comment_id +" .votes .row.value").text( display_value );
            }
        }, function(data) {
            Alert.showGeneralAlert("Something went wrong, try again");
            if("remove" === intent) {
                jQuery(rate_el).addClass("voted-for");
            } else {
                jQuery(rate_el).removeClass("voted-for");
                if(other_rate_voted) {
                    jQuery(other_rate_el).addClass("voted-for");
                }
            }
        });
    }

    static initEvents() {
        jQuery(document.body)
            .on('submit', "form.comment-form", function(evt) {
                evt.preventDefault();
                Comments.onCommentSubmit(jQuery(this));
            })
            .on('click', ".comment_reply", function(evt) {
                evt.preventDefault();
                Comments.onCommentReplyLink(jQuery(this));
            })
            .on('click', ".cancel_comment", function(evt) {
                evt.preventDefault();
                Comments.onCommentReplyCancel(jQuery(this));
            })
            .on('click', ".comment_delete", function(evt) {
                evt.preventDefault();
                Comments.onCommentDelete(jQuery(this));
            })
            .on('click', "[data-vote-comment]", function(evt) {
                evt.preventDefault();
                Comments.onCommentVote(jQuery(this));
            });
    }
    static initModule() {
        Comments.initEvents();
    }
}

export default Comments;